import cn from 'classnames';
import PropTypes from 'prop-types';

import { Row, RowSpan } from 'components/checkout/caap/Layout';
import { getPaymentTypeDisplayText, getPaymentTypeIcon } from 'components/checkout/CheckoutUtils';
import styles from 'styles/components/checkout/caap/payment/paymentlist/cardInfo.scss';

const CardInfo = (componentParams, { testId }) => {
  const {
    addCreditCardNumber,
    expirationMonth,
    expirationYear,
    fullName,
    isExpired,
    paymentType
  } = componentParams;

  return (
    <div data-test-id={testId('cardInfo')}>
      <Row>
        <RowSpan mobileSpan="12" desktopSpan="5">
          <PaymentBlock paymentType={paymentType} addCreditCardNumber={addCreditCardNumber} />
        </RowSpan>
        <RowSpan mobileSpan="12" desktopSpan="4">
          <NameBlock fullName={fullName} />
        </RowSpan>
        <RowSpan mobileSpan="12" desktopSpan="3">
          <ExpirationBlock isExpired={isExpired} expirationMonth={expirationMonth} expirationYear={expirationYear} />
        </RowSpan>
      </Row>
    </div>
  );
};

export const ExpirationBlock = ({ expirationMonth, expirationYear, isExpired }, { testId }) => (
  <Row>
    <RowSpan span="12">
      <div className={isExpired ? styles.expired : ''} data-test-id={testId('ccExpBlock')}>
        <span className={styles.showOnlySmallScreen}>Expires</span> {expirationMonth}/{expirationYear}
      </div>
    </RowSpan>
  </Row>
);

export const NameBlock = ({ fullName }, { testId }) => (
  <Row>
    <RowSpan span="12" data-test-id={testId('ccNameBlock')}>
      <div className={styles.forceWrap}>{fullName}</div>
    </RowSpan>
  </Row>
);

export const PaymentBlock = ({ addCreditCardNumber, paymentType }, { testId }) => {
  const paymentIconStyles = cn(
    styles.paymentTypeIcon,
    styles.hideSmallScreen,
    {
      [styles.bordered]: paymentType === 'Visa' || paymentType === 'MasterCard'
    }
  );

  return (
    <Row>
      <RowSpan span="12">
        <span className={paymentIconStyles}>
          {getPaymentTypeIcon(paymentType)}
        </span>
        <span className={styles.cardNumber} data-test-id={testId('ccPaymentBlock')}>{getPaymentTypeDisplayText(paymentType)} **** {addCreditCardNumber}</span>
      </RowSpan>
    </Row>
  );
};

CardInfo.contextTypes = {
  testId: PropTypes.func
};

ExpirationBlock.contextTypes = {
  testId: PropTypes.func
};

NameBlock.contextTypes = {
  testId: PropTypes.func
};

PaymentBlock.contextTypes = {
  testId: PropTypes.func
};

export default CardInfo;
